import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import popimg from "../../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../../Common/Images/ImagesForAlert/popup_close_n.png";

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

const YEAR_OPTIONS = ["ALL", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];

interface EC_ValidateQnTypesProps {
    onClose?: () => void;
}

const EC_ValidateQnTypes: React.FC<EC_ValidateQnTypesProps> = ({ onClose }) => {
    const [curriculumOptions, setCurriculumOptions] = useState<string[]>([]);
    const [curriculum, setCurriculum] = useState("");
    const [year, setYear] = useState("ALL");
    const [running, setRunning] = useState(false);
    const [loadingOptions, setLoadingOptions] = useState(true);
    const navigate = useNavigate()

    useEffect(() => {
        document.body.style.backgroundColor = "azure"
    })

    useEffect(() => {
        const fetchCurriculumOptions = async () => {
            try {
                const res = await fetch(
                    `${API_BASE_URL}api/el-ec-validate-qn-types/get-curriculum-options/`
                );
                const data = await res.json();
                const options: string[] = data.options || [];
                setCurriculumOptions(options);
                if (options.length > 0) {
                    setCurriculum(options[0]);
                }
            } catch (err) {
                // eslint-disable-next-line no-alert
                window.alert("An error occurred while loading curriculum options.");
            } finally {
                setLoadingOptions(false);
            }
        };

        fetchCurriculumOptions();
    }, []);

    const handleGo = async () => {
        setRunning(true);
        try {
            const res = await fetch(`${API_BASE_URL}api/el-ec-validate-qn-types/run-validation/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ curriculum, year }),
            });
            const data = await res.json();

            // VB: fn_StartValidation() checks ErrorMesg first, then AlertMesg
            if (data.errorMesg) {
                // eslint-disable-next-line no-alert
                window.alert(data.errorMesg);
            } else if (data.alertMesg) {
                // eslint-disable-next-line no-alert
                window.alert(data.alertMesg);
            }
        } catch (err) {
            // eslint-disable-next-line no-alert
            window.alert("An error occurred while running the validation.");
        } finally {
            setRunning(false);
        }
    };

    const handleBack = () => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <>
            <style>{`
        .ec-validate-wrapper {
          font-family: Arial;
          font-size: 14pt;
          padding: 16px;
        }
        .ec-validate-wrapper select {
          border: solid 1px #003300;
          font-family: Arial;
          font-size: 14pt;
          height: 25px;
        }
        #ddlCurriculum {
          width: 166px;
        }
        #btnGO, #btnBack {
          font-family: Arial;
          font-size: 14pt;
          margin-left: 20px;
        }
        #btnBack {
          float: right;
        }
      `}</style>

            <div
                style={{
                    backgroundImage: `url(${popimg}), url(${popbg})`,
                    backgroundRepeat: "no-repeat, no-repeat",
                    backgroundPosition: "left center, right center",
                    backgroundSize: "30% 100%, 70% 100%",
                    height: "16px",
                    color: "white",
                    padding: "7px 0px",
                    fontWeight: "bold",
                    fontSize: "12pt",
                    fontFamily: "arial",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                }}
            >
                <span style={{ marginLeft: "10px" }}>
                    Validate EC question types
                </span>
                <img
                    src={popclose}
                    alt="close"
                    height="30px"
                    style={{ cursor: "pointer" }}
                    onClick={() => window.close()}
                />
            </div>

            <div className="ec-validate-wrapper">
                Curriculum:&nbsp;
                <select
                    id="ddlCurriculum"
                    value={curriculum}
                    onChange={(e) => setCurriculum(e.target.value)}
                    disabled={loadingOptions}
                >
                    {curriculumOptions.map((opt) => (
                        <option key={opt} value={opt}>
                            {opt}
                        </option>
                    ))}
                </select>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Year:
                <select id="ddlYear" value={year} onChange={(e) => setYear(e.target.value)}>
                    {YEAR_OPTIONS.map((y) => (
                        <option key={y} value={y}>
                            {y}
                        </option>
                    ))}
                </select>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button id="btnGO" type="button" onClick={handleGo} disabled={running || loadingOptions}>
                    {running ? "Running..." : " GO "}
                </button>
                {/* <button id="btnBack" type="button" onClick={handleBack}>
                    back
                </button> */}
            </div>
        </>
    );
};

export default EC_ValidateQnTypes;